import "./Button.css";

/*
 * COLOR OPTIONS FOR BUTTONS:
    * - red
    * - green
    * - blue
    * - yellow
    * - purple
    * - orange
    * - gray
    * - dark
    * - white
 */
export default function Button(props) {
    const variantClass = props.variant ? `icon-button--${props.variant}` : '';
    const colorClass = props.color ? `icon-button--${props.color}` : '';
    const IconComponent = props.icon;

    return <button 
        className={`icon-button ${variantClass} ${colorClass}`.trim()}
        title={props.text}
        onClick={props.onClick}
        disabled={props.disabled}
    >
        {IconComponent && <IconComponent className="icon-button__svg" />}
        <span>{props.text}</span>
    </button>
}
